/**
 * Select only uninitilized controls, to give the possibility to re-run init after an
 * ajax call without affecting previous initilized shortcodes
 */
const getElements = className => {
  
  const elements = document.querySelectorAll(`.${className}:not([data-init="true"])`)

  elements.forEach( element => element.setAttribute('data-init', 'true') )

  return elements
}

export { getElements }

